<section class="section-1">
    <h2 class="center">Signing you out from Manzoul....</h2>
</section>